import React from 'react'
import classNames from 'classnames'

export type TitleProps = React.ComponentPropsWithoutRef<'span'>

export const Title = ({ className, ...rest }: TitleProps) => (
  <span
    className={classNames('testimonial-card__title', className)}
    {...rest}
  />
)
